
import { mapState, mapGetters, mapActions } from 'vuex'
import Avatar from './avatar.vue'

export default {
  components: { Avatar },
  props: {
    redirectAdminMode: {type: String, required: false},
    darkModeSwitch: {type: Boolean, default: true},
  },
  computed: {
    ...mapState('session', ['user', 'initialized', 'directoryUrl']),
    ...mapGetters('session', ['activeAccount'])
  },
  methods: {
    ...mapActions('session', ['logout', 'login', 'switchOrganization', 'asAdmin', 'cancelDeletion']),
    setDarkCookie (value) {
      const maxAge = 60 * 60 * 24 * 100 // 100 days
      this.$cookies.set('theme_dark', '' + value, { maxAge, path: '/' })
      window.location.reload()
    },
    setAdminMode (value) {
      const redirect = value ? null : this.redirectAdminMode
      this.$store.dispatch('session/setAdminMode', { value, redirect })
    }
  }
}
